import React from 'react';
import styled from 'styled-components';

import { Expand } from '@e4/ui';
import {
  UnorderedList as BaseUnorderedList,
  AnchorItem as BaseAnchorItem,
} from '../../UnorderedList';
import MenuCSS from './MenuCSS';

const IconSize = '0.8rem';

const Submenu = ({ items, topOffset, visible }) => (
  <UnorderedList visible={visible} topOffset={topOffset}>
    {items
      ? items.map(
          (item, index) =>
            ((
              <AnchorItem
                key={`burgerSubMenuItem_${index}_${item.text}`}
                {...item}
                Icon={ArrowIcon}
                iconSize={IconSize}
                HSpacerProps={null}
              />
            ): null)
        )
      : null}
  </UnorderedList>
);

const UnorderedList = styled(BaseUnorderedList)`
  display: block;
  background-color: ${({ theme }) => theme.PrimaryB_30}};
  z-index: 10;

  ${MenuCSS}
`;

const AnchorItem = styled(BaseAnchorItem)`
  padding: 0.8rem;

  :not(:last-child) {
    border-bottom: ${({ theme }) => `1px solid ${theme.GreyC_60}`}};
  }

  &:hover {
    background-color: ${({ theme }) => theme.PrimaryB_70}};
  }

  > a {
    justify-content: space-between;
  }
`;

const ArrowIcon = styled(Expand)`
  transform: rotate(270deg);
`;

export default Submenu;
